<template>
  <!--
    แพ็กของร้านไม่มีฟีเจอร์/รายงานนี้ (API 403 ERROR_FEATURE_NOT_AVAILABLE)
    คนละเรื่องกับ <access-denied /> ที่แปลว่า "พนักงานคนนี้ไม่มีสิทธิ์" — ทางแก้ต่างกัน:
      access-denied        → ขอสิทธิ์จากเจ้าของร้าน
      feature-not-available → เจ้าของร้านติดต่อเราเพื่ออัปเกรดแพ็ก
    (../silver-spoon-api/docs/plans-subscriptions.md §7)
  -->
  <div class="card mb-0 border-0 shadow-0">
    <div class="card-body text-center py-5 mb-5">
      <div class="mt-5 mb-4">
        <span class="feature-na__icon text-theme">
          <i class="fa-solid fa-lock" />
        </span>
      </div>
      <h1 class="error-page-title">
        {{ $t('_plan.Not included in your plan') }}
      </h1>
      <div class="error-page-text">
        <div>{{ $t('_plan.This feature is not available on your current plan') }}</div>
        <div>{{ $t('_plan.Contact support to upgrade your plan') }}</div>
      </div>
      <div
        v-if="contact.phone"
        class="mt-3"
      >
        <a
          :href="telHref"
          class="feature-na__phone text-theme"
        >
          <i class="fa-solid fa-phone me-2" />{{ contact.phone }}
        </a>
      </div>
      <div
        v-if="backRoute"
        class="mt-4"
      >
        <button
          class="btn btn-lg btn-theme"
          @click="$router.push({ name: backRoute })"
        >
          <i class="fas fa-arrow-alt-circle-left me-2" />
          {{ $t(backText) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SUPPORT_CONTACT } from '@/stores/license.store';

export default {
  props: {
    // ชื่อ route ของปุ่มย้อนกลับ · ไม่ใส่ = ไม่มีปุ่ม
    backRoute: {
      type: String,
      default: '',
    },
    backText: {
      type: String,
      default: 'Go Back',
    },
  },
  computed: {
    // เบอร์เดียวกับหน้าล็อก license — ค่าเดียวทุกร้าน ฟิกซ์ที่ license.store
    contact() {
      return SUPPORT_CONTACT;
    },
    telHref() {
      return `tel:${String(SUPPORT_CONTACT.phone).replace(/[^0-9+]/g, '')}`;
    },
  },
};
</script>

<style scoped>
.feature-na__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #f8f9fa;
  font-size: 52px;
}

.feature-na__phone {
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
}
</style>
